import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Zap } from "lucide-react";

export default function Footer() {
  const { t } = useTranslation();
  const year = new Date().getFullYear();

  return (
    <footer className="border-t border-border/30 bg-background mt-16">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10 py-10">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          <div className="col-span-2 md:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-3">
              <Zap className="h-5 w-5 text-volt" strokeWidth={2.5} />
              <span className="font-heading text-xl tracking-tight">Go<span className="text-volt">Captain</span></span>
            </Link>
            <p className="text-xs text-muted-foreground/80 leading-relaxed max-w-[200px]">
              {t("footer.tagline")}
            </p>
          </div>
          <div>
            <div className="text-[10px] tracking-[0.2em] uppercase text-volt font-semibold mb-3">{t("footer.platform")}</div>
            <div className="flex flex-col gap-2">
              <Link to="/search" className="text-xs text-muted-foreground hover:text-volt transition-colors">{t("nav.explore")}</Link>
              <Link to="/bookings" className="text-xs text-muted-foreground hover:text-volt transition-colors">{t("nav.bookings")}</Link>
              <Link to="/chats" className="text-xs text-muted-foreground hover:text-volt transition-colors">{t("nav.chats")}</Link>
            </div>
          </div>
          <div>
            <div className="text-[10px] tracking-[0.2em] uppercase text-volt font-semibold mb-3">{t("footer.support")}</div>
            <div className="flex flex-col gap-2">
              <a href="mailto:support@gocaptain.app" className="text-xs text-muted-foreground hover:text-volt transition-colors">{t("footer.contact")}</a>
              <Link to="/" className="text-xs text-muted-foreground hover:text-volt transition-colors">{t("footer.faq")}</Link>
            </div>
          </div>
          <div>
            <div className="text-[10px] tracking-[0.2em] uppercase text-volt font-semibold mb-3">{t("footer.legal")}</div>
            <div className="flex flex-col gap-2">
              <span className="text-xs text-muted-foreground">{t("footer.terms")}</span>
              <span className="text-xs text-muted-foreground">{t("footer.privacy")}</span>
            </div>
          </div>
        </div>
        <div className="mt-10 pt-6 border-t border-border/30 flex flex-wrap items-center justify-between gap-4">
          <span className="text-[10px] tracking-widest uppercase text-muted-foreground/60">
            &copy; {year} Go<span className="text-volt">Captain</span>. {t("footer.rights")}
          </span>
          <span className="text-[10px] tracking-widest uppercase text-muted-foreground/40">
            🇯🇴 {t("footer.made_in")}
          </span>
        </div>
      </div>
    </footer>
  );
}